<template>
  <v-app >
    <!-- <v-app-bar app color="primary" dark></v-app-bar> -->
    <overlay-spinner ref="loader"></overlay-spinner>
    <HeaderMenu /> 

    <v-main class="content">      
      <router-view />
    </v-main>
    <div class="footer">
      <Footer />
    </div>
  </v-app>
</template>

<script>
 import { mapState } from 'vuex'
 import customThemes from '@/plugins/themes.js'
 import HeaderMenu from '@/components/header/HeaderMenu'
 import Footer from '@/components/Footer'
 import OverlaySpinner from '@/components/OverlaySpinner'

 export default {
   name: 'App',

   components: {
     Footer,
     HeaderMenu,
     OverlaySpinner,
   },
   data: () => ({
 
      OverlaySpinner    //
   }),

   computed: {
     ...mapState(['allSites', 'sitePath']),
   },

   mounted () {
     this.$root.$loader = this.$refs.loader;
   },

   watch: {
     allSites() {
       // Change the theme with qmkey_product from the current site
       if (this.allSites) {
         const currentSite = this.allSites.filter(
           site => site.path === this.sitePath,
         )
         if (currentSite.length > 0 && currentSite[0].qmkey_product) {
           this.changeTheme(currentSite[0].qmkey_product.toLowerCase());
         }
       }
     },
   },

   methods: {
     // Vuetify theme changer, on the fly
     changeTheme: function(theme_name) {
       // theme_name must be a valid entry key in customThemes
       // example: changeTheme("qmkey")

       const theme = customThemes[theme_name];
       if (!theme)
         throw "Error, theme \""+theme_name+"\" not found";

       // Copy theme information to vuetify theme
       Object.keys(theme.light || {}).forEach(i => {
         this.$vuetify.theme.themes.light[i] = theme.light[i];
       });
       Object.keys(theme.dark || {}).forEach(i => {
         this.$vuetify.theme.themes.dark[i] = theme.dark[i];
       });
     },
   }
 }
</script>
